import React from 'react';
import DemoMessage from './DemoMessage';
import DemoArchLayer from './DemoArchLayer';
import DemoUSPBadges from './DemoUSPBadges';

const DemoNarrative = ({ scenario, persona }) => {
  if (!scenario || !persona) {
    return (
      <div className="demo-narrative">
        <div className="demo-narrative-empty">Select a persona and scenario to view narrative.</div>
      </div>
    );
  }

  return (
    <div className="demo-narrative">
      <div className="demo-capability-label">
        {scenario.capabilityLabel}
      </div>

      <DemoArchLayer activeLayers={scenario.activeLayers} />

      <div className="demo-narrative-box">
        <div className="demo-persona-description">
          <strong>{persona.name} ({persona.title})</strong> – {persona.shortDescription}
        </div>

        <div className="demo-scenario-header">
          <h3 className="demo-scenario-title">{scenario.title}</h3>
          <div style={{ margin: '6px 0 8px' }}>
            <DemoUSPBadges uspTags={scenario.uspTags} />
          </div>
          <div className="demo-scenario-goal">Goal: {scenario.goal}</div>
        </div>

        <div className="demo-messages">
          {scenario.messages.map((message, index) => (
            <DemoMessage key={index} message={message} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DemoNarrative;
